import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Base_Url } from '../config';
import { Mail, Phone, Briefcase, Award, GraduationCap, MapPin, ChevronDown, X } from 'lucide-react';
import './StaffProfiles.css';
import dummy from "../Assests/dummy.jpg";
import { Link } from 'react-router-dom';

const StaffProfiles = () => {
  const [head, setHead] = useState([]);
  const [srSysManager, setSrSysManager] = useState([]);
  const [sysManager, setSystemManager] = useState([]);
  const [sysArchitect, setSysArchitect] = useState([]);
  const [staff, setStaff] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Base_Url}/profiles`);
      const data = response.data;

      const filteredData = data.filter(person => 
        person.show_in_display === 1 && person.isretired === 0
      );

      setHead(filteredData.filter(person =>
        person.designation === 'Sr. System Manager (SG)' &&
        person.show_hod === 1
      ));
      setSrSysManager(filteredData.filter(person =>
        person.designation === 'Sr. System Manager (SG)'
      ));
      setSystemManager(filteredData.filter(person =>
        person.designation === 'System Manager'
      ));
      setSysArchitect(filteredData.filter(person =>
        person.designation === 'System Architect'
      ));
      setStaff(filteredData.filter(person =>
        !['System Manager', 'Sr. System Manager (SG)', 'System Architect'].includes(person.designation)
      ));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleProfileClick = (profile) => {
    setSelectedProfile(profile === selectedProfile ? null : profile);
  };

  const renderProfileSummary = (profile) => {
    return (
      <div className="card mt-3 border-0 shadow">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title text-primary mb-0">Profile Details</h5>
            <button 
              className="btn-close"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProfile(null);
              }}
            ></button>
          </div>

          {/* Contact Information */}
          <div className="bg-light p-3 rounded mb-3">
            <h6 className="text-secondary mb-3">Contact Information</h6>
            <div className="d-flex flex-column gap-2">
              {profile.email && (
                <div className="d-flex align-items-center gap-2">
                  <Mail size={16} className="text-primary" />
                  <span className="small text-muted">{profile.email}</span>
                </div>
              )}
              {profile.phone && (
                <div className="d-flex align-items-center gap-2">
                  <Phone size={16} className="text-primary" />
                  <span className="small text-muted">{profile.phone}</span>
                </div>
              )}
              {profile.location && (
                <div className="d-flex align-items-center gap-2">
                  <MapPin size={16} className="text-primary" />
                  <span className="small text-muted">{profile.location}</span>
                </div>
              )}
            </div>
          </div>

          {/* Professional Background */}
          <div className="mb-3">
            <h6 className="text-secondary mb-3">Professional Background</h6>
            <div className="d-flex flex-column gap-2">
              {profile.experience && (
                <div className="d-flex align-items-center gap-2">
                  <Briefcase size={16} className="text-primary" />
                  <span className="small text-muted">{profile.experience} Years Experience</span>
                </div>
              )}
              {profile.education && (
                <div className="d-flex align-items-center gap-2">
                  <GraduationCap size={16} className="text-primary" />
                  <span className="small text-muted">{profile.education}</span>
                </div>
              )}
              {profile.specialization && (
                <div className="d-flex align-items-center gap-2">
                  <Award size={16} className="text-primary" />
                  <span className="small text-muted">{profile.specialization}</span>
                </div>
              )}
            </div>
          </div>

          {/* Expertise */}
          {profile.expertise && (
            <div className="mb-3">
              <h6 className="text-secondary mb-3">Areas of Expertise</h6>
              <div className="d-flex flex-wrap gap-2">
                {profile.expertise.split(',').map((item, index) => (
                  <span 
                    key={index} 
                    className="badge bg-primary bg-opacity-10 text-primary"
                  >
                    {item.trim()}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Summary */}
          {profile.summary && (
            <div>
              <h6 className="text-secondary mb-2">Professional Summary</h6>
              <p className="small text-muted mb-0">{profile.summary}</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderProfileSection = (title, profiles) => {
    if (!profiles || profiles.length === 0) return null;

    return (
      <div className="mb-5">
        <h2 className="h3 mb-4 pb-2 border-bottom text-dark">{title}</h2>
        <div className="row g-4">
          {profiles.map((profile, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div 
                className={`card h-100 shadow-sm transition-all ${
                  selectedProfile === profile ? 'border-primary' : 'border-0'
                }`}
                onClick={() => handleProfileClick(profile)}
                style={{ cursor: 'pointer' }}
              >
                <div className="card-body text-center p-4">
                  {/* Profile Image */}
                  <div className="position-relative mb-4 mx-auto" style={{ width: '140px', height: '140px' }}>
                    <div className="rotating-border position-absolute"></div>
                    <img
                      src={profile.image_path ? `${Base_Url}/${profile.image_path}` : dummy}
                      alt={profile.name}
                      className="rounded-circle img-thumbnail shadow-sm"
                      style={{ width: '140px', height: '140px', objectFit: 'cover' }}
                    />
                  </div>

                  {/* Profile Info */}
                  <Link className='text-decoration-none' to={`/info/${profile.id}`}>
                  <h3 className="h5 mb-2 d-flex justify-content-center">{profile.name}</h3>
                  <p className="text-danger small fw-semibold mb-3">{profile.designation}</p>
                  </Link>

                  {/* Contact Icons */}
                  <div className="d-flex justify-content-center gap-3 mb-3">
                    {profile.email && (
                      <a href={`mailto:${profile.email}`} className="text-muted hover-primary" onClick={e => e.stopPropagation()}>
                        <Mail size={20} />
                      </a>
                    )}
                    {profile.phone && (
                      <a href={`tel:${profile.phone}`} className="text-muted hover-primary" onClick={e => e.stopPropagation()}>
                        <Phone size={20} />
                      </a>
                    )}
                  </div>

                  <p className="text-muted small mb-3 line-clamp-3">{profile.summary}</p>

                  {/* <button className={`btn btn-link text-decoration-none ${
                    selectedProfile === profile ? 'text-primary' : 'text-muted'
                  }`}>
                    View Details 
                    <ChevronDown size={16} className={`ms-1 transition-transform ${
                      selectedProfile === profile ? 'rotate-180' : ''
                    }`} />
                  </button> */}
                </div>

                {/* Expandable Details */}
                {/* {selectedProfile === profile && renderProfileSummary(profile)} */}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="container py-5">
      {renderProfileSection("HEAD", head)}
      {renderProfileSection("SR. SYSTEM MANAGER (SG)", srSysManager)}
      {renderProfileSection("SYSTEM MANAGER", sysManager)}
      {renderProfileSection("SYSTEM ARCHITECT", sysArchitect)}
      {renderProfileSection("TECHNICAL & NETWORK STAFF", staff)}
    </div>
  );
};

export default StaffProfiles;